/* istanbul ignore file - better tested visually */
import StepLabel, { StepLabelProps } from '@mui/material/StepLabel';
import { forwardRef } from 'react';
import { VerticalStepIcon } from '../VerticalStepIcon';
import styles from './VerticalStepLabel.module.scss';

type VerticalStepLabelProps = Omit<StepLabelProps, 'classes' | 'StepIconComponent' | 'StepIconProps'>;

export const VerticalStepLabel = forwardRef<HTMLSpanElement, VerticalStepLabelProps>((props, ref) => (
  <StepLabel
    {...props}
    classes={{
      label: styles.label,
      active: styles.active,
      disabled: styles.disabled,
      root: styles.root,
    }}
    StepIconComponent={VerticalStepIcon}
    ref={ref}
  />
));
